import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Helper function to convert Firebase UID to numeric ID (example - consider if needed)
export const generateNumericId = (uid: string): number => {
  // Convert the UID to a number by summing the ASCII values of its characters
  const numericId = uid.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  // Ensure the ID is positive and within a reasonable range
  return Math.abs(numericId) % 1000000000; // Limit to 9 digits
};
